/**
 * SkillDelivery Platform — WMS Showcase
 * Copyright © 2026 SKD RATWANI Technology & Software Solutions Pvt Ltd
 * All Rights Reserved.
 * PROPRIETARY AND CONFIDENTIAL
 *
 * Content authored by Lalit Ratwani, drawing from 22+ years of
 * Manhattan WMS implementation practice (2003-2026).
 */

import React from 'react';

const VARIANTS = {
  cyan: 'bg-brand-cyan/10 text-brand-cyanDark border border-brand-cyan/30',
  blue: 'bg-brand-bgOff2 text-brand-blueDark border border-brand-borderAccent',
  muted: 'bg-brand-bgOff text-brand-muted border border-brand-border',
};

const MetaBadge = ({ value, label, variant = 'cyan' }) => {
  if (!value) return null;
  const cls = VARIANTS[variant] || VARIANTS.cyan;
  return (
    <span
      className={`inline-flex items-center gap-1 rounded-brandPill px-2.5 py-0.5 text-[10px] font-bold uppercase tracking-wider ${cls}`}
    >
      {label && <span className="opacity-60">{label}:</span>}
      <span>{value}</span>
    </span>
  );
};

export default MetaBadge;
